import { CourseDto } from '../../modules/Courses/models/Course.dto';
import axiosInstance from '../api/axios';

export async function getMyCourses() {
  try {
    const response = await axiosInstance.get(`/myarea/courses`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function gethCourses(): Promise<CourseDto[]> {
  const response = await axiosInstance.get(`/courses`);

  return response.data;
}

export async function gethUserCourses(showAds: boolean): Promise<any[]> {
  const response = await axiosInstance.get(`/courses/user?showAds=${showAds}`);

  return response.data;
}

export async function getCourseDetails(slug: string) {
  try {
    const response = await axiosInstance.get(`/courses/${slug}/details`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function loadCourse(slug: string) {
  try {
    const response = await axiosInstance.get(`/courses/${slug}/load`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function startCourse(slug: string) {
  const response = await axiosInstance.post(`/courses/${slug}/start`);

  return response.data;
}

export async function dropCourse(slug: string, reasons?: string[]) {
  const response = await axiosInstance.post(`/courses/${slug}/drop`, {
    reasons,
  });

  return response.data;
}

export async function retakeCourse(slug: string) {
  const response = await axiosInstance.post(`/courses/${slug}/retake`);

  return response.data;
}

export async function getProgram(courseId: string, programId: string) {
  try {
    const response = await axiosInstance.get(
      `/courses/${courseId}/programs/${programId}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getCourseHasSimulationWeek(
  courseSlug: string,
  programId: string
) {
  try {
    const response = await axiosInstance.post(
      `/simulatedweek/existSimulationWeekInCourse/${courseSlug}`,
      {
        programId,
      }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function fetchContent(
  courseId: string,
  programId: string,
  contentId: string
) {
  try {
    const response = await axiosInstance.get(
      `/courses/${courseId}/programs/${programId}/content/${contentId}`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function markContentAsSelected(
  courseId: string,
  programId: string,
  contentId: string
) {
  const response = await axiosInstance.post(
    `/courses/${courseId}/mark/content/${contentId}/selected`,
    {
      program: programId,
    }
  );

  return response.data;
}

export async function markProgramAsSelected(
  courseId: string,
  programId: string
) {
  const response = await axiosInstance.post(
    `/courses/${courseId}/mark/program/${programId}/selected`
  );

  return response.data;
}

export const verifyExerciseAnswer = async (
  courseId: string,
  contentId: string,
  exerciseId: string,
  answers: string[],
  status: string
) => {
  try {
    const response = await axiosInstance.post(
      `/courses/${courseId}/content/${contentId}/exercises/${exerciseId}/verify`,
      {
        answer: answers,
        status,
      }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const updateExerciseSelectedAlternative = async (
  courseId: string,
  contentId: string,
  exerciseId: string,
  answers: string[]
) => {
  try {
    const response = await axiosInstance.post(
      `/courses/${courseId}/content/${contentId}/exercises/${exerciseId}`,
      {
        answer: answers,
      }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export async function markContentAsDone(
  courseId: string,
  programId: string,
  contentId: string
) {
  const response = await axiosInstance.post(
    `/courses/${courseId}/mark/content/${contentId}/done`,
    {
      program: programId,
      done: true,
    }
  );

  return response.data;
}
